import React, { Component } from 'react'
import Logo from '../../images/login-logo.png';
import './login.css';
import Data from '.././data/users.json';
 
export default class login extends Component {

    state = {
        data: Data,
        email: '',
        pass: '',
        userName: '',
        showMsgError: false    
    }

    

    handleChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name]:value});
        this.setState({ showMsgError: false });
    }

    isLogged = () => {
        var res = false;
        this.state.data.map( elemento => {
            if( elemento.username === this.state.email && elemento.pass === this.state.pass){   
                this.state.name = elemento.name;
                res = true; 
            }                    
        })
        return res;
    }

    handleSubmit = e => { 
        if( this.isLogged() === true ){
            e.preventDefault();
            console.log("Is Logged");
            this.props.isLogin(true);            
        }else{            
            this.setState({ showMsgError: true }); 
            console.log("Is Not Logged " + this.state.showMsgError);
            e.preventDefault();
        }         
    }

    render() {
        return (            
            <div className="body-form">
                <div className="content">
                    <div className="c-image">
                        <img src={Logo} alt="Logo" />
                    </div> 
                    <div className="c-title">
                        My App
                    </div>
                    <div className="c-form">
                        <form onSubmit={this.handleSubmit} >
                            <div className="label-title" ><label>Email</label> <br/></div>
                            <input 
                                className="input-e"
                                type='email' 
                                name='email' 
                                placeholder='You can test with example@gmail.com' 
                                required 
                                onChange={this.handleChange} 
                                value={this.state.email.toLowerCase()}
                            />                             
                            <div className="label-title"><label>Password</label> <br/></div>                               
                            <input 
                                className="input-p"
                                type='password' 
                                name='pass' 
                                placeholder='You can Test with examplepass2021' 
                                required 
                                onChange={this.handleChange} 
                                value={this.state.pass.toLowerCase()}
                            />
                            <div className="forgotPass">
                                <a href="#">Forgot Password?</a>
                            </div>
                            <button 
                                className="btnLogin"
                                onSubmit={this.handleSubmit}>
                                Log In
                            </button>
                            {
                                this.state.showMsgError?
                                <p className="msg_error" >                            
                                    Email/Passwords Incorrect
                                </p> 
                                : null
                            }                      
                            
                        </form>
                    </div>                
                </div>
            </div>
        )
    }
}


